var newsLists = {

  'newsLists': [
    {
      'name': 'cctv',
      'newsId': 'news0505',
      'detail1': 'news0505',
      'top': true,
      'title': 'CCTV News丨 SENSORO IoT Technology Ensuring City Security',
      'date': '2018/05/05',
      'newsCover': '/static/image/news/cctv@1x.jpg',
      'newsCover1': '/static/image/news/cctv@2x.jpg',
    },
    {
      'name': 'fire-library',
      'newsId': 'news1030',
      'detail1': 'news1030',
      'title': 'Sensoro weaves a protection net for library',
      'date': '2019/10/30',
      'newsCover': '/static/image/news/pic_news_19103002@1x.jpg',
      'newsCover1': '/static/image/news/pic_news_19103002@2x.jpg'
    },
    {
      'name': 'fire-stadium',
      'newsId': 'news1029',
      'detail1': 'news1029',
      'title': 'SENSORO Smart Security Service shoots the pain point of firefighting management of Stadium',
      'date': '2019/10/29',
      'newsCover': '/static/image/news/pic_news_191029@1x.jpg',
      'newsCover1': '/static/image/news/pic_news_191029@2x.jpg'
    },
    {
      'name': 'solitary',
      'newsId': 'news0903',
      'detail1': 'news0903',
      'title': '30 seconds, SENSORO successfully rescued a solitary elderly',
      'date': '2019/09/03',
      'newsCover': '/static/image/news/pic_news_190903@1x.jpg',
      'newsCover1': '/static/image/news/pic_news_190903@2x.jpg'
    },
    {
      'name': 'forest-fire',
      'newsId': 'news0902',
      'detail1': 'news0902',
      'title': 'Forest fire protection calling for smart high technology',
      'date': '2019/09/02',
      'newsCover': '/static/image/news/pic_news_190902@1x.jpg',
      'newsCover1': '/static/image/news/pic_news_190902@2x.jpg'
    },
    {
      'name': 'singapore',
      'newsId': 'news0619',
      'detail1': 'news0619',
      'title': 'Singapore University of Technology and Design arrived SENSORO ',
      'date': '2019/06/19',
      'newsCover': '/static/image/news/pic_news_190619@1x.jpg',
      'newsCover1': '/static/image/news/pic_news_190619@2x.jpg'
    },
    {
      'name': 'fishing',
      'newsId': 'news190119',
      'detail1': 'news190119',
      'title': 'Smart firefighting safeguards fishing port',
      'date': '2019/01/19',
      'newsCover': '/static/image/news/pic_news_190109@1x.jpg',
      'newsCover1': '/static/image/news/pic_news_190109@2x.jpg'
    },
    {
      'name': 'school',
      'newsId': 'news190103',
      'detail1': 'news190103',
      'title': 'IoT Smart Firefighting forges safe campus',
      'date': '2019/01/03',
      'newsCover': '/static/image/news/pic_news_190103@1x.jpg',
      'newsCover1': '/static/image/news/pic_news_190103@2x.jpg'
    },
    {
      'name': 'fire',
      'newsId': 'news0607',
      'detail1': 'news0607',
      'title': '2018 Beijing Fire Protection丨SENSORO uses cutting IoT technology to create Smart Fire Protection',
      'date': '2018/06/07',
      'newsCover': '/static/image/news/FIRE@1x.jpg',
      'newsCover1': '/static/image/news/FIRE@2x.jpg'
    },
    {
      'name': 'if-award',
      'newsId': 'news0130',
      'detail1': 'news0130',
      'title': 'SENSORO has won 2018 iF product design award, boasting three top Industrial Design Oscars.',
      'date': '2018/01/30',
      'newsCover': '/static/image/news/2018-iF-product-design-@1x.jpg',
      'newsCover1': '/static/image/news/2018-iF-product-design-@2x.jpg'

    },
    {
      'name': 'CES',
      'newsId': 'news0613',
      'detail1': 'news0613',
      'title': 'Punching CES Asia in to unlock SENSORO security service of smart city',
      'date': '2018/06/13',
      'newsCover': '/static/image/news/Punching-CES@1x.jpg',
      'newsCover1': '/static/image/news/Punching-CES@2x.jpg'

    },
    {
      'name': 'anniversary',
      'newsId': 'news181230',
      'detail1': 'news181230',
      'title': 'SENSORO was invited to attend Cambodia 20-year anniversary exhibition of Win-Win policy',
      'date': '2018/12/30',
      'newsCover': '/static/image/news/pic_news_181230@1x.jpg',
      'newsCover1': '/static/image/news/pic_news_181230@2x.jpg'

    },
    {
      'name': ' Paris',
      'newsId': 'news190416',
      'detail1': 'news190416',
      'title': 'Grieved for Paris ----SENSORO protecting net for brittle civilization heritages',
      'date': '2019/04/16',
      'newsCover': '/static/image/news/news190416@1x.jpg',
      'newsCover1': '/static/image/news/news190416@2x.jpg'

    },
    {
      'name': ' Mount',
      'newsId': 'news190130',
      'detail1': 'news190130',
      'title': 'Mount Wutai Zhenrong Temple forged IoT “smart temple” with SENSORO ',
      'date': '2019/01/30',
      'newsCover': '/static/image/news/pic_news_190130_1@1x.jpg',
      'newsCover1': '/static/image/news/pic_news_190130_1@2x.jpg'

    },

  ],
}

module.exports = {

  newsLists: newsLists
}



// WEBPACK FOOTER //
// ./src/assets/js/news.js